import React, { memo, PropsWithChildren } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'

// https://github.com/staylor/react-helmet-async

const Head: React.FC<PropsWithChildren> = (props) => {
  const { children } = props
  return (
    <Helmet prioritizeSeoTags>{React.Children.toArray(children).filter((child) => React.isValidElement(child))}</Helmet>
  )
}

export default memo(Head)
